import React, { useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { Outlet } from "react-router";
import { ActiveDistrictContextProvider } from "./Constant";
import Header from "./Header/Header";

const Container = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  width: "100%",
  margin: "auto",
  overflow: "auto",
  maxHeight: `calc(100% - 0px)`,
  height: "100%",
}));

const Internal = (props) => {
  const [showMenu, setShowMenu] = useState(true);
  const [showFooter, setShowFooter] = useState(false);
  const headerValue = useMemo(() => ({ showMenu, setShowMenu }), [showMenu]);
  const footerValue = useMemo(() => ({ showFooter, setShowFooter }), [showFooter]);

  return (
    <React.Fragment>
      <ActiveDistrictContextProvider headerValue={headerValue} footerValue={footerValue}>
        <Header />
        <Box
          component="main"
          sx={(theme) => {
            return {
              flexGrow: 1,
              overflowY: "auto",
              height: "100vh",
              paddingTop: theme.mixins.toolbar.minHeight + 40 + "px",
              paddingX: 5,
              paddingBottom: showFooter ? 10 : 5,
              background: showMenu ? "inherit" : "#ffffff",
            };
          }}
        >
          <Container gap={3}>
            <Outlet />
          </Container>
        </Box>
      </ActiveDistrictContextProvider>
    </React.Fragment>
  );
};

export default React.memo(Internal);
